import React from 'react';

const Header = ({IndexPage}) => (
	<div className="logo">
		<a href={IndexPage} />
	</div>
);

export default Header;
